import { useState, useEffect, Suspense } from 'react'
import { Await, defer, Link, useSearchParams, useNavigate, useLoaderData, useActionData, json, Form, Navigate } from 'react-router-dom'
import { Title } from './helper/DocumentTitle'
import styles from '../styles/module/PassageNew.module.scss'
import LoadingSpinner from './components/LoadingSpinner'
import { getRequestType, setRequest } from '../util/p_api'
import * as L from 'leaflet/dist/leaflet'
import Logo from './../logo.svg'
import MarkerIcon from './../images/marker-icon.png'
import * as leafletDraw from 'leaflet-draw'
import '../../node_modules/leaflet-draw/dist/leaflet.draw.css'

export const loader = async ({params}) => {
    console.log(params)
  return defer({
    requestType: getRequestType(),
    user: JSON.parse(localStorage.getItem('Response')),
  })
}
let map, tileLayer, addressMap, marker
let layerOnMap = []
let shapeLayerGroup

export default function Ardabil() {
  const pageName = 'نام گذاری معابر'
  Title(pageName)
  const [loaderData, setLoaderData] = useState(useLoaderData())
  const [data, setData] = useState()
  const [error, setError] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const [showPopup, setShowPopup] = useState(false)
  const [layers, setLayers] = useState()
  let [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate()
  const errors = useActionData()

  const mapInit = () => {
    let cloudmadeUrl = 'https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png',
      cloudmade = new L.TileLayer(cloudmadeUrl, { maxZoom: 19 })
    let southWest = L.latLng(38.1798206357761, 48.21865389083308),
      northEast = L.latLng(38.30520008275403, 48.345629549549045),
      bounds = L.latLngBounds(southWest, northEast)

    map = new L.Map('map', {
      zoomSnap: 0.5,
      maxBounds: bounds,
      fullscreenControl: true,
      layers: [cloudmade],
      center: new L.LatLng(38.243063632250085, 48.29758857470783),
      zoom: 12,
    })

    tileLayer = L.tileLayer('https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png', {
      apikey: '<your apikey>',
      attribution: '',
      subdomains: 'abcd',
      minZoom: 0,
      maxZoom: 20,
      ext: 'png',
    }).addTo(map)

    // Add a fresh layer, to group the shapes
    shapeLayerGroup = L.layerGroup().addTo(map)

    var editableLayers = new L.FeatureGroup()
    map.addLayer(editableLayers)

    let MyCustomMarker = L.Icon.extend({
      options: {
        shadowUrl: null,
        iconAnchor: new L.Point(12, 12),
        iconSize: new L.Point(25, 41),
        iconUrl: MarkerIcon,
      },
    })

    var options = {
      position: 'topright',
      draw: {
        polyline: {
          shapeOptions: {
            color: '#f357a1',
            weight: 10,
          },
        },
        polygon: {
          allowIntersection: false, // Restricts shapes to simple polygons
          drawError: {
            color: '#e1e100', // Color the shape will turn when intersects
            message: "<strong>Oh snap!<strong> you can't draw that!", // Message that will show when intersect
          },
          shapeOptions: {
            color: '#FF5A47',
          },
        },
        circlemarker: false,
        rectangle: false,
        marker: {
          icon: new MyCustomMarker(),
        },
      },
      edit: {
        featureGroup: editableLayers, //REQUIRED!!
        remove: false,
      },
    }

    var drawControl = new L.Control.Draw(options)
    map.addControl(drawControl)

    map.on(L.Draw.Event.CREATED, function (e) {
      console.log(e.layer)
      let type = e.layerType,
        layer = e.layer

      layerOnMap.push(layer)

      
     
      switch (type) {
        case 'circle':
         // setLayers([{ type: 'circle', latlng: [layer._latlng], radius: layer._mRadius }])
          layer.bindPopup('از نوع دایره')
          break
        case 'polyline':
          //setLayers([{ type: 'polyline', latlng: [layer._latlngs] }])
          layer.bindPopup('از نوع خطی')
          break
        case 'polygon':
         // setLayers([{ type: 'polygon', latlng: layer._latlngs }])
          layer.bindPopup('از نوع ذوزنقه')
          break
        case 'marker':
          //setLayers([{ type: 'marker', latlng: layer._latlng }])
          layer.bindPopup('پین نقطه ای')
          break
      }

      setLayers(layer.toGeoJSON())
      editableLayers.addLayer(layer)
    })
  }

  const addressMapInit = () => {
    let cloudmadeUrl = 'https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png',
      cloudmade = new L.TileLayer(cloudmadeUrl, { maxZoom: 19 })

    let southWest = L.latLng(38.1798206357761, 48.21865389083308),
      northEast = L.latLng(38.30520008275403, 48.345629549549045),
      bounds = L.latLngBounds(southWest, northEast)

    addressMap = new L.Map('addressMap', {
      zoomSnap: 0.5,
      maxBounds: bounds,
      fullscreenControl: true,
      layers: [cloudmade],
      center: new L.LatLng(38.243063632250085, 48.29758857470783),
      zoom: 14,
    })

    let MyCustomMarker = L.Icon.extend({
      options: {
        shadowUrl: null,
        iconAnchor: new L.Point(12, 12),
        iconSize: new L.Point(25, 41),
        iconUrl: MarkerIcon,
      },
    })

    var greenIcon = L.icon({
      shadowUrl: null,
      iconAnchor: new L.Point(12, 12),
      iconSize: new L.Point(25, 41),
      iconUrl: MarkerIcon,
    })

    let marker = new L.marker([38.243063632250085, 48.29758857470783], {
      draggable: true,
      autoPan: true,
      icon: greenIcon,
    }).addTo(addressMap)

    addressMap.on('drag', (event) => {
      // console.log(addressMap.getCenter())
      marker.setLatLng(addressMap.getCenter())
      document.querySelector('#address_location').value = `${marker.getLatLng().lat}, ${marker.getLatLng().lng}`
      document.querySelector('#addressMap span').innerText = `${marker.getLatLng().lat}, ${marker.getLatLng().lng}`
    })

    marker.on('dragend', (event) => {
      console.log(marker.getLatLng())
      document.querySelector('#address_location').value = `${marker.getLatLng().lat}, ${marker.getLatLng().lng}`
      document.querySelector('#addressMap span').innerText = `${marker.getLatLng().lat}, ${marker.getLatLng().lng}`

      var requestOptions = {
        method: 'GET',
        redirect: 'follow',
      }

      fetch(`https://nominatim.openstreetmap.org/reverse?lat=${marker.getLatLng().lat}&lon=${marker.getLatLng().lng}&format=jsonv2&accept-language=fa`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          console.log(result)
          document.querySelector(`input[name='address']`).value = `${result.address.city}-${result.address.city_district}-${result.address.neighbourhood}-${result.address.road}`
        })
        .catch((error) => console.log('error', error))
    })

    tileLayer = L.tileLayer('https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png', {
      apikey: '<your apikey>',
      attribution: '',
      subdomains: 'abcd',
      minZoom: 0,
      maxZoom: 20,
      ext: 'png',
    }).addTo(addressMap)

    // Add a fresh layer, to group the shapes
    shapeLayerGroup = L.layerGroup().addTo(addressMap)

    var editableLayers = new L.FeatureGroup()
    addressMap.addLayer(editableLayers)

    var options = {
      position: 'topright',
      draw: {
        polyline: {
          shapeOptions: {
            color: '#f357a1',
            weight: 10,
          },
        },
        polygon: {
          allowIntersection: false, // Restricts shapes to simple polygons
          drawError: {
            color: '#e1e100', // Color the shape will turn when intersects
            message: "<strong>Oh snap!<strong> you can't draw that!", // Message that will show when intersect
          },
          shapeOptions: {
            color: '#FF5A47',
          },
        },
        circlemarker: false,
        rectangle: false,
        marker: {
          icon: new MyCustomMarker(),
        },
      },
      edit: {
        featureGroup: editableLayers, //REQUIRED!!
        remove: false,
      },
    }
  }

  const cleanUpMap = () => {
    if (layerOnMap.length < 1) return
    layerOnMap.forEach((item) => {
      item.remove()
    })
    layerOnMap = []

    document.querySelectorAll(`.btnViewShape span`).forEach((item) => (item.innerText = 'visibility_off'))
    document.querySelectorAll(`.btnViewShape`).forEach((item) => item.removeAttribute('data-layer-id'))
  }

  useEffect(() => {
    document.querySelector('header span').innerText = pageName
    mapInit()
    addressMapInit()
  }, [])

  return (
    <section className={styles.section}>
      <div className={`__frame`} data-width={`large`}>
        <div className={styles.formContainer} style={{ border: '2px solid #333' }}>
          <div className="alert alert--danger">
            فیلدهای اجباری با
            <span style={{ color: 'red', margin: '0 1rem' }}>*</span>
            مشخص شده اند.
          </div>

          <div className="alert alert--info">
            لطفا کروکی محل مورد نظر را در نقشه زیر مشخص نمایید.
            <button onClick={() => cleanUpMap()}>پاکسازی نقشه</button>
          </div>

          <div id="map" className={styles.map} />

          {errors && <Navigate to="../list" />}

          <Suspense fallback={<LoadingSpinner />}>
            <Await resolve={loaderData.user} errorElement={<p>⚠️</p>}>
              {(data) => {
                console.log(data)
                return (
                  <>
                    <Form className="form" method="post" action="/passage/new">
                      <div className={styles.formGroup}>
                        <label>موضوع درخواست نام گذاری</label>
                        <Suspense fallback={<LoadingSpinner />}>
                          <Await resolve={loaderData.requestType} errorElement={<p>⚠️ مشکل در واکشی نوع درخواست</p>}>
                            {(data) => (
                              <select name={'request_type_id'} autoFocus>
                                {data.map((item, i) => (
                                  <option key={i} value={item.id}>
                                    {++i}) {item.name}
                                  </option>
                                ))}
                              </select>
                            )}
                          </Await>
                        </Suspense>
                      </div>

                      <div className={styles.formGroup}>
                        <label data-required="1">نام و نام خانوادگی متقاضی</label>
                        <input type={'text'} name={'fullname'} defaultValue={data.firstName + ' ' + data.lastName} required readOnly />
                      </div>

                      <div className={styles.formGroup}>
                        <label data-required="1">شماره تلفن</label>
                        <input type={'number'} name={'tel'} minLength={11} maxLength={15} defaultValue={data.mobile} required readOnly />
                      </div>

                      <div className={styles.formGroup}>
                        <label data-required="1">آدرس محل مورد نظر</label>
                        <input type={'text'} name={'address'} placeholder="لطفا آدرس دقیق را در  این قسمت درج فرمایید یا از طریق نقشه آدرس خود را انتخاب نمایید." required />
                        <details hidden>
                          <summary>انتخاب آدرس از روی نقشه</summary>
                          <div id="addressMap" className={styles.map}>
                            <span className={styles.latlong} />
                          </div>
                          <input type="hidden" value="" id="address_location" name="address_location" />
                        </details>
                        <br />
                      </div>

                      <div className={styles.formGroup}>
                        <label>عنوان تابلو در صورت موجود بودن</label>
                        <input type={'text'} name={'title'} />
                      </div>

                      <div className={styles.formGroup}>
                        <label>نام محل (به چه نامی مشهور است)</label>
                        <input type={'text'} name={'name'} />
                      </div>

                      <div className={styles.formGroup}>
                        <label data-required="1">نام پیشنهادی 1</label>
                        <input type={'text'} name={'suggestion_name1'} required />
                      </div>

                      <div className={styles.formGroup}>
                        <label>نام پیشنهادی 2</label>
                        <input type={'text'} name={'suggestion_name2'} />
                      </div>

                      <div className={styles.formGroup}>
                        <label>نام پیشنهادی 3</label>
                        <input type={'text'} name={'suggestion_name3'} />
                      </div>

                      <input type="hidden" name="layer" value={JSON.stringify(layers)} />

                      <div className={styles.formGroup}>
                        <button type="submit" className={styles.submitButton}>
                          ارسال درخواست و دریافت فرم نام گذاری
                        </button>
                      </div>
                    </Form>
                  </>
                )
              }}
            </Await>
          </Suspense>
        </div>
      </div>
    </section>
  )
}

export const action = async ({ request, params }) => {
  console.clear()
  const formData = await request.formData()

  let suggestion_names = []
  if (formData.get('suggestion_name1')) suggestion_names.push(formData.get('suggestion_name1'))
  if (formData.get('suggestion_name2')) suggestion_names.push(formData.get('suggestion_name2'))
  if (formData.get('suggestion_name3')) suggestion_names.push(formData.get('suggestion_name3'))

  const post = {
    request_type_id: formData.get('request_type_id'),
    fullname: formData.get('fullname'),
    address: formData.get('address'),
    address_location: formData.get('address_location'),
    tel: formData.get('tel'),
    title: formData.get('title'),
    name: formData.get('name'),
    layer: formData.get('layer'),
    suggestion_names: JSON.stringify(suggestion_names),
  }

  try {
    const res = await setRequest(post)
    console.log(res)
    if (res.result) {
      alert('درخواست با موفقیت ارسال گردید')
      return true
    }
  } catch (error) {
    console.log(error)
  }

  return null
}
